import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Media from "react-media";

class Navigation extends Component{
  render(){
    if (!this.props.user) {
      return (
        <nav className="nav-restricted">
          <NavLink exact to='/' id="logo"/>
          <ul className="navbar-right">
            {/*<li><NavLink to="/dashboard"> <span />Register</NavLink></li>*/}
            <li><NavLink to="/home"> <span />Login</NavLink></li>
          </ul>
        </nav>
      );
    }else{
      return (
        <nav className="main-nav">
          <NavLink exact to='/' id="logo"/>

          <Media query="(max-width: 425px)">
            {matches =>
              matches ? (
                <ul style={{width: 0}}>
                  <li className="no-hover dropdown">
                    <button type="button" name="button" className="icon-menu"/>
                    <ul className="dropdown-menu dropdown-menu-sm">
                      <li id="dropdown">
                        <NavLink to='/logout'><span className="icon-logout"/>Logout</NavLink>
                      </li>
                      <li id="dropdown">
                        <NavLink to='/services'>Services</NavLink>
                      </li>
                      <li id="dropdown">
                        <NavLink to='/locations'>Locations</NavLink>
                      </li>
                      <li id="dropdown">
                        <NavLink to='/invoices'>Invoices</NavLink>
                      </li>
                      <li id="dropdown">
                        <NavLink to='/quotes'>Quotes</NavLink>
                      </li>
                      {this.props.user.profile.cf_cdb_admin === 'true' ?
                        <li id="dropdown">
                          <NavLink to='/admin'>Admin</NavLink>
                        </li>
                      : null}
                    </ul>
                  </li>
                </ul>
              ) : (
                <ul>
                  <li>
                  <NavLink exact to='/dashboard'>Dashboard</NavLink>
                  </li>
                  <li>
                    <NavLink to='/locations'>Locations</NavLink>
                  </li>
                  <li>
                    <NavLink to='/services'>Services</NavLink>
                  </li>
                  <li>
                    <NavLink to='/invoices'>Invoices</NavLink>
                  </li>
                  <li>
                    <NavLink to='/quotes'>Quotes</NavLink>
                  </li>
                  {this.props.user.profile.cf_cdb_admin === 'true' ?
                    <li>
                      <NavLink to='/admin'>Admin</NavLink>
                    </li>
                  : null}
                  <li className="no-hover dropdown">
                    <NavLink to="#" className="user-email">{this.props.user.profile.name}</NavLink>
                    <ul className="dropdown-menu">
                      <li id="dropdown">
                        <NavLink to="/logout"> <span className="icon-logout" />Logout</NavLink>
                      </li>
                    </ul>
                  </li>
                  <li className="no-hover">
                    <button type="button" name="button" className="icon-user"/>
                  </li>
                </ul>
              )
            }
          </Media>
        </nav>
      );
    }
  }
}

const mapStateToProps = function(state) {
  return {
    user: state.oidc.user
  }
};

//export default NavMenu;
export default withRouter(connect(mapStateToProps)(Navigation));
